import Lottie from 'react-lottie';
import PropTypes from 'prop-types';

/**
 * LottieAnimation
 *  - A component extended from react-lottie package and tailored to
 *  - serve animations for scrollable component.
 */
export class Animation extends Lottie {}

Animation.propTypes = {
  /**
   * The animation playback options
   */
  options: PropTypes.shape({
    loop: PropTypes.bool,
    autoplay: PropTypes.bool,
    path: PropTypes.string.isRequired,
    rendererSettings: PropTypes.shape({
      preserveAspectRatio: PropTypes.string,
    }),
  }).isRequired,
  /**
   * This is an array of objects containing a eventName and callback function
   * that will be registered as eventlisteners on the animation object.
   */
  eventListeners: PropTypes.arrayOf(
    PropTypes.shape({
      eventName: PropTypes.string,
      callback: PropTypes.func,
    })
  ),
  /**
   * Boolean value to determine if clickToPause options avaliable
   */
  isClickToPauseDisabled: PropTypes.bool,
  /**
   * Boolean value specifying if the animation is paused
   */
  isPaused: PropTypes.bool,
  /**
   * Inline style object
   */
  style: PropTypes.object,
};

Animation.defaultProps = {
  ...Lottie.defaultProps,
  style: {pointerEvents: 'none'},
  isPaused: true,
  isClickToPauseDisabled: true,
};
